import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'

import { BreadCrumbs, Button, Container, LinkButton, breakpoint, styles as S, stickers } from '@bob/design-system'

import * as url from '@bob/url'

export default function Custom404(): React.ReactElement {
  return (
    <>
      <Container>
        <BreadCrumbs crumbs={url.notFound().crumbs} />
      </Container>
      <Section>
        <StickerBlock>
          <stickers.others.NotFound size={162} />
        </StickerBlock>
        <div>
          <S.heading.Title2>Oups, vous êtes perdu·e ?</S.heading.Title2>
          <S.copy.Text5>
            La page que vous recherchez n’existe pas, ou plus. Pas de panique, on vous montre le chemin !
          </S.copy.Text5>
          <LinkGroup>
            <Link prefetch={false} href={url.homepage().path}>
              <Button>{"Retourner à l'accueil"}</Button>
            </Link>
          </LinkGroup>
        </div>
      </Section>
    </>
  )
}

const Section = styled.section`
  margin-bottom: 80px;
  margin-top: 25px;
  padding: 0px 20px;

  @media screen and (${breakpoint.TABLET}) {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    margin-top: 60px;
  }

  ${S.heading.Title2} {
    max-width: 250px;

    @media screen and (${breakpoint.TABLET}) {
      max-width: 100%;
    }
  }

  ${S.copy.Text5} {
    margin: 26px 0px 36px;

    @media screen and (${breakpoint.TABLET}) {
      max-width: 410px;
    }
  }

  ${stickers.others.NotFound} {
    height: 184px;
    width: 184px;

    @media screen and (${breakpoint.TABLET}) {
      height: 262px;
      width: 262px;
      margin-left: 20px;
    }
  }
`

const StickerBlock = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`

const LinkGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 80px;
  padding: 0px 20px;

  @media screen and (${breakpoint.TABLET}) {
    flex-direction: row;
    margin-bottom: 0px;
    padding: 0px;
  }

  ${Button} {
    width: 296px;
  }

  ${LinkButton} {
    margin-top: 38px;

    @media screen and (${breakpoint.TABLET}) {
      margin-left: 32px;
      margin-top: 0px;
    }
  }
`
